import { render, staticRenderFns } from "./correct_rep.vue?vue&type=template&id=a6aff062&scoped=true&"
import script from "./correct_rep.vue?vue&type=script&lang=js&"
export * from "./correct_rep.vue?vue&type=script&lang=js&"
import style0 from "./correct_rep.vue?vue&type=style&index=0&id=a6aff062&scoped=true&lang=less&"
import style1 from "./correct_rep.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6aff062",
  null
  
)

export default component.exports